import conceptionImg from "../../../assets/images/creation.jpg";
import entretien from "../../../assets/images/entretien.jpg";

export const specialites = [
  {
    title: "Création",
    image: conceptionImg,
    text: `<p>Du végétal, évidemment mais pas que ! 
    Allées, terrasses, clôtures & portails, bassins, éclairages, pergolas & voiles d’ombrage... La liste est longue ! Contactez nous pour en savoir plus. </p>`,
    url: "/creation",
  },
  {
    title: "Entretien",
    image: entretien,
    text: `<p>Maison individuelle, immeuble, lotissement, commune, nos équipes sont là pour prendre soin de vos espaces verts. Tonte, taille, ramassage des feuilles, nettoyage de massifs...<p>`,
    url: "/entretien",
  },
];
